import { RigidBody } from "@react-three/rapier";
import { RoundedBox } from "@react-three/drei";
import { COLORS } from "../../../constants/colors";

const RectangleBlock = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  return (
    <RigidBody
      type="fixed"
      colliders="cuboid"
      restitution={1}
      ccd={false}
      position={position}
      rotation={rotation}
    >
      <RoundedBox
        args={[0.5, 1.5, 6]}
        radius={0.2}
        color="#ebbf7f"
        metalness={0.3}
        roughness={0.7}
      >
        <meshStandardMaterial color={COLORS.kubes} />
      </RoundedBox>
    </RigidBody>
  );
};

export default RectangleBlock;
